import { PlaceApi, placesApi } from "api/places/placesApi";
import { useEffect, useState } from "react";

export const usePlace = (placeId: number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<PlaceApi | null>(null);

  useEffect(() => {
    const fetchPlace = async () => {
      if (!placeId) {
        console.error("Place id not found.");
        setLoading(false);
        return;
      }
      const res = await placesApi.fetchById(placeId);
      try {
        setData(res.data);
      } catch (error) {
        // Handle error appropriately, perhaps with another state variable
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlace();
  }, [placeId]);

  return { loading, data };
};
